import axios from "axios";
import { backendURL } from "../url";

const API_URL = "/api/listing";

export const getAllListings = async (activeOnly: boolean = false) => {
  try {
    const params = activeOnly ? { active: 'true' } : {};
    const response = await axios.get(
      `${backendURL}${API_URL}/get-all-listings`,
      { params }
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/get-all-listings`
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching listings:", error.message);
    throw error;
  }
};

export const createListing = async (listingData: any) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${backendURL}${API_URL}/create-listing`,
    // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/create-listing`,
    listingData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getListingByID = async (listingID: string) => {
  try {
    const response = await axios.get(
      `${backendURL}${API_URL}/get-listing/${listingID}`
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/get-listing/${listingID}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching listing by ID:", error.message);
    throw error;
  }
};

export const checkAvailability = async (data: any) => {
  try {
    const response = await axios.post(
      `${backendURL}/api/booking/check-availability`,
      // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/check-availability`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error("Error checking availability:", error.message);
    throw error;
  }
};

export const updateListing = async (listingID: string, listingData: any) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${backendURL}${API_URL}/update-listing/${listingID}`,
    // `${process.env.REACT_APP_BACKEND_URL}${API_URL}/update-listing/${listingID}`,
    listingData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getVideoUrl = async () => {
  try {
    const response = await axios.get(`${backendURL}${API_URL}/get-tour-video`);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching video URL:", error.message);
    throw error;
  }
};

export const toggleListingActiveStatus = async (listingID: string, active: boolean) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.patch(
      `${backendURL}${API_URL}/toggle-active/${listingID}`,
      { active },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error toggling listing active status:", error.message);
    throw error;
  }
};
